//----- Thema references --------------------------------------------------------------------
/**
 * Thema codes are well structured, with child codes having the parent code as prefix.
 * Hence, not necessary to list all children for each term (as for GenreAndForm) to
 * support testing on higher levels in the hierarchy.
 */
export const ThemaRef = {
  ['Høyere utdanning']: '4CT',
  ['Intellektuelt nivå']: '5A',
  ['For alle utdanningsnivå']: '4C',
  ['For spesifikke nasjonale eller regionale læreplaner']: '4Z',
} as const;
